import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { LUXURY, IMAGE_CARD_FRAME } from "data/guestLuxuryTheme";

const FeaturedFoodCard = ({
  title = "Extraordinary Flavors Await",
  hint = "Discover chef specialties and seasonal dishes from your room.",
  ctaLabel = "View Menu",
  onClick,
  dots = 4,
  activeDot = 0,
}) => (
  <Box
    component={motion.button}
    type="button"
    onClick={onClick}
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    sx={{
      appearance: "none",
      WebkitTapHighlightColor: "transparent",
      border: IMAGE_CARD_FRAME.border,
      bgcolor: "transparent",
      outline: "none",
      cursor: "pointer",
      width: "100%",
      textAlign: "left",
      display: "block",
      minHeight: 196,
      p: 0,
      borderRadius: "20px",
      overflow: "hidden",
      position: "relative",
      boxShadow: IMAGE_CARD_FRAME.boxShadow,
      transition: "transform 0.18s ease",
      "&:focus": { outline: "none" },
      "&:active": { transform: "scale(0.985)" },
    }}
  >
    <Box
      component="img"
      src={LUXURY.foodImage}
      alt=""
      sx={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.35) 38%, rgba(0,0,0,0.82) 100%)",
      }}
    />
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        minHeight: 196,
        px: 2.1,
        pt: 2,
        pb: 1.85,
      }}
    >
      <Typography
        sx={{
          fontFamily: LUXURY.displayFont,
          fontWeight: 500,
          fontSize: { xs: "1.55rem", sm: "1.7rem" },
          lineHeight: 1.12,
          color: "#fff",
          maxWidth: "88%",
          wordBreak: "break-word",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          mt: 0.55,
          fontSize: "0.78rem",
          lineHeight: 1.4,
          color: "rgba(255,255,255,0.72)",
          maxWidth: "86%",
          wordBreak: "break-word",
        }}
      >
        {hint}
      </Typography>
      <Box
        sx={{
          mt: 1.45,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.55,
            minHeight: 38,
            px: 1.85,
            borderRadius: 999,
            background: LUXURY.ctaGradient,
            color: LUXURY.forestDeep,
            fontSize: "0.82rem",
            fontWeight: 700,
            boxShadow: LUXURY.ctaShadow,
          }}
        >
          {ctaLabel}
          <Icon icon="mdi:arrow-right" width={16} height={16} color="currentColor" />
        </Box>
        {dots > 1 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.55 }}>
            {Array.from({ length: dots }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: index === activeDot ? 14 : 6,
                  height: 6,
                  borderRadius: 999,
                  bgcolor:
                    index === activeDot ? LUXURY.gold : "rgba(255,255,255,0.35)",
                  transition: "width 0.2s ease",
                }}
              />
            ))}
          </Box>
        ) : null}
      </Box>
    </Box>
  </Box>
);

export default FeaturedFoodCard;
